import * as React from 'react';

import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import Divider from '@mui/material/Divider';
import Download from '@mui/icons-material/Download';

import {
  GridCsvExportMenuItem,
  GridPrintExportMenuItem,
  GridToolbarExport,
} from '@mui/x-data-grid-pro';

type ExportProps = React.ComponentProps<typeof GridToolbarExport>;

function CustomExport({
  csvOptions,
  printOptions,
  exportExtraItems,
}: {
  csvOptions?: ExportProps['csvOptions'];
  printOptions?: ExportProps['printOptions'];
  exportExtraItems?: React.ReactNode;
}) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  return (
    <>
      <Button
        variant="text"
        size="small"
        startIcon={<Download />}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        Export
      </Button>

      <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
        <GridCsvExportMenuItem options={csvOptions} />
        <GridPrintExportMenuItem options={printOptions} />

        {exportExtraItems ? (
          <>
            <Divider />
            {exportExtraItems}
          </>
        ) : null}
      </Menu>
    </>
  );
}

export default CustomExport;